import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';

const FlowEditor = () => import('./pages/FlowEditor.vue');
const FlowList = () => import('./pages/FlowList.vue');

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.FLOWBUILDER,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flowbuilder'),
    component: FlowList,
    name: 'flowbuilder_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/flowbuilder/:flowId'),
    component: FlowEditor,
    name: 'flowbuilder_edit',
    meta,
  },
];
